var map = {
	"./activity.svg": 76496,
	"./add-circle.svg": 64789,
	"./add-fill.svg": 31919,
	"./add.svg": 99718,
	"./airplay.svg": 57219,
	"./alert-circle.svg": 77033,
	"./alert-octagon.svg": 83283,
	"./alert-triangle-fill.svg": 60272,
	"./alert-triangle.svg": 95234,
	"./align-center.svg": 42874,
	"./align-justify.svg": 26343,
	"./align-left.svg": 46473,
	"./align-right.svg": 7823,
	"./anchor.svg": 27757,
	"./aperture.svg": 36305,
	"./archive-fill.svg": 74497,
	"./archive.svg": 21590,
	"./arrow-down-circle.svg": 24334,
	"./arrow-down-fill.svg": 64024,
	"./arrow-down-left.svg": 88994,
	"./arrow-down-right.svg": 32624,
	"./arrow-down.svg": 28139,
	"./arrow-left-circle.svg": 85994,
	"./arrow-left-fill.svg": 67614,
	"./arrow-left.svg": 48940,
	"./arrow-long-right-fill.svg": 77697,
	"./arrow-long-right.svg": 40099,
	"./arrow-right-circle.svg": 86091,
	"./arrow-right-fill.svg": 69990,
	"./arrow-right.svg": 18652,
	"./arrow-up-circle.svg": 81900,
	"./arrow-up-fill.svg": 26384,
	"./arrow-up-left.svg": 82396,
	"./arrow-up-right.svg": 98248,
	"./arrow-up.svg": 78364,
	"./at-sign.svg": 56715,
	"./attach.svg": 48756,
	"./award-fill.svg": 27477,
	"./award.svg": 59574,
	"./bar-chart-2.svg": 57069,
	"./bar-chart.svg": 77776,
	"./battery-charging.svg": 4075,
	"./battery-fill.svg": 99437,
	"./battery.svg": 89109,
	"./bluetooth.svg": 53411,
	"./bold.svg": 1862,
	"./book-open.svg": 87724,
	"./book.svg": 71139,
	"./bookmark.svg": 40458,
	"./box.svg": 4833,
	"./branch.svg": 98141,
	"./briefcase.svg": 30710,
	"./business-card-fill.svg": 82735,
	"./business-card.svg": 66485,
	"./calendar-fill.svg": 99063,
	"./calendar-x.svg": 57771,
	"./calendar.svg": 73178,
	"./camera-fill.svg": 65695,
	"./camera-off-fill.svg": 57425,
	"./camera-off.svg": 77486,
	"./camera.svg": 72780,
	"./campaign-fill.svg": 20462,
	"./campaign.svg": 90875,
	"./cast.svg": 22936,
	"./chart-fill.svg": 46741,
	"./chart.svg": 17296,
	"./check-circle.svg": 43502,
	"./check-square.svg": 63975,
	"./check.svg": 5110,
	"./checkmark.svg": 34180,
	"./chevron-down-fill.svg": 71586,
	"./chevron-down.svg": 12020,
	"./chevron-left-fill.svg": 86782,
	"./chevron-left.svg": 25998,
	"./chevron-right-fill.svg": 59158,
	"./chevron-right.svg": 97780,
	"./chevron-up-fill.svg": 2345,
	"./chevron-up.svg": 49216,
	"./chevrons-down.svg": 2058,
	"./chevrons-left.svg": 10441,
	"./chevrons-right.svg": 35910,
	"./chevrons-up.svg": 13500,
	"./chrome.svg": 18030,
	"./circle-fill.svg": 51518,
	"./circle.svg": 51351,
	"./click.svg": 33444,
	"./clipboard-fill.svg": 88553,
	"./clipboard.svg": 89401,
	"./clock-filled.svg": 23128,
	"./clock.svg": 71279,
	"./cloud-drizzle.svg": 60222,
	"./cloud-fill.svg": 61190,
	"./cloud-lightning.svg": 9661,
	"./cloud-off-fill.svg": 56118,
	"./cloud-off.svg": 95497,
	"./cloud-rain.svg": 90221,
	"./cloud-snow.svg": 8482,
	"./cloud.svg": 44188,
	"./code.svg": 93329,
	"./codepen.svg": 30790,
	"./collapse-vertical.svg": 41017,
	"./collapse.svg": 43037,
	"./command.svg": 53986,
	"./communication-fill.svg": 75823,
	"./communication.svg": 36233,
	"./company-fill.svg": 19497,
	"./company.svg": 27044,
	"./compass.svg": 47940,
	"./contact-add-user-plus.svg": 99205,
	"./contact-user.svg": 2312,
	"./contacts-users.svg": 26372,
	"./conversation.svg": 90983,
	"./copy.svg": 15101,
	"./corner-down-left.svg": 5888,
	"./corner-down-right.svg": 83207,
	"./corner-left-down.svg": 42268,
	"./corner-left-up.svg": 67274,
	"./corner-right-down.svg": 61011,
	"./corner-right-up.svg": 43790,
	"./corner-up-left.svg": 55716,
	"./corner-up-right.svg": 92818,
	"./credit-card-fill.svg": 94988,
	"./credit-card.svg": 19241,
	"./crop.svg": 42719,
	"./crosshair-fill.svg": 59179,
	"./crosshair.svg": 41109,
	"./cursor-click-fill.svg": 20306,
	"./cursor-click.svg": 11820,
	"./database.svg": 71007,
	"./delete.svg": 15347,
	"./disc.svg": 66200,
	"./dollar.svg": 75869,
	"./download-cloud.svg": 20252,
	"./download.svg": 56905,
	"./draggable.svg": 37144,
	"./droplet.svg": 40089,
	"./edit-2-fill.svg": 55693,
	"./edit-2.svg": 30855,
	"./edit.svg": 30147,
	"./email-fill.svg": 80045,
	"./email-open-fill.svg": 73287,
	"./email-open.svg": 74058,
	"./email.svg": 93482,
	"./emoji-fill.svg": 34455,
	"./emoji.svg": 56864,
	"./euro.svg": 52330,
	"./expand-vertical.svg": 9519,
	"./expand.svg": 82667,
	"./external-link.svg": 24216,
	"./eye-hide.svg": 82739,
	"./eye-show.svg": 86222,
	"./eyedropper-fill.svg": 41334,
	"./eyedropper.svg": 90858,
	"./facebook-fill.svg": 1173,
	"./facebook.svg": 66411,
	"./fast-forward-fill.svg": 37535,
	"./fast-forward.svg": 34122,
	"./feather.svg": 7430,
	"./file-fill.svg": 53247,
	"./file-minus-fill.svg": 28201,
	"./file-minus.svg": 49060,
	"./file-plus-fill.svg": 64459,
	"./file-plus.svg": 52862,
	"./file.svg": 78730,
	"./film.svg": 82115,
	"./filter.svg": 16312,
	"./fire-fill.svg": 17554,
	"./fire.svg": 3298,
	"./flag-fill.svg": 60010,
	"./flag.svg": 1005,
	"./folder-fill.svg": 47613,
	"./folder-minus-fill.svg": 87081,
	"./folder-minus.svg": 98685,
	"./folder-plus-fill.svg": 72216,
	"./folder-plus.svg": 60995,
	"./folder.svg": 51831,
	"./font.svg": 50824,
	"./form-fill.svg": 99347,
	"./form.svg": 41758,
	"./funnel-fill.svg": 97206,
	"./funnel.svg": 73560,
	"./gift-fill.svg": 83012,
	"./gift.svg": 25060,
	"./git-commit.svg": 43083,
	"./git-pull-request.svg": 30302,
	"./github.svg": 77870,
	"./gitlab.svg": 29467,
	"./globe.svg": 53442,
	"./grid.svg": 95924,
	"./hamburger-fill.svg": 62723,
	"./hamburger.svg": 67265,
	"./hard-drive.svg": 88706,
	"./hash.svg": 15015,
	"./headphones-mic-fill.svg": 97217,
	"./headphones-mic.svg": 44483,
	"./headphones.svg": 49356,
	"./heart-fill.svg": 96564,
	"./heart.svg": 90100,
	"./help-circle-fill.svg": 27094,
	"./help-circle.svg": 22616,
	"./home-fill.svg": 67921,
	"./home.svg": 42985,
	"./image.svg": 68573,
	"./inbox.svg": 9050,
	"./info-circle-fill.svg": 32679,
	"./info-circle.svg": 28483,
	"./instagram-fill.svg": 45236,
	"./instagram.svg": 41988,
	"./integrations-fill.svg": 86514,
	"./integrations.svg": 5271,
	"./italic.svg": 88744,
	"./keap-up-left.svg": 32606,
	"./keap-up-right.svg": 70268,
	"./key-command.svg": 23396,
	"./key-delete-fill.svg": 113,
	"./key-delete.svg": 21456,
	"./layers.svg": 31013,
	"./layout.svg": 51606,
	"./life-buoy-fill.svg": 30173,
	"./life-buoy.svg": 84406,
	"./lightbulb-fill.svg": 66113,
	"./lightbulb.svg": 53170,
	"./lightning-fill.svg": 56285,
	"./link-horiz.svg": 70355,
	"./link.svg": 88938,
	"./linkedin-fill.svg": 46579,
	"./linkedin.svg": 79182,
	"./list-cards.svg": 25361,
	"./list-fill.svg": 27849,
	"./list-num.svg": 13669,
	"./list-unordered.svg": 88303,
	"./list.svg": 87307,
	"./loader.svg": 14959,
	"./location-fill.svg": 60121,
	"./location.svg": 41521,
	"./lock-locked-fill.svg": 84140,
	"./lock-locked.svg": 21003,
	"./lock-unlocked-fill.svg": 92326,
	"./lock-unlocked.svg": 52890,
	"./lock.svg": 43868,
	"./log-in.svg": 71168,
	"./log-out.svg": 61329,
	"./map.svg": 39678,
	"./mark-unread.svg": 9965,
	"./maximize-2.svg": 80330,
	"./maximize.svg": 73712,
	"./megaphone-fill.svg": 25435,
	"./megaphone.svg": 65727,
	"./merge-field.svg": 6988,
	"./merge.svg": 34718,
	"./message-fill.svg": 23778,
	"./message-none.svg": 75144,
	"./message-square-fill.svg": 56584,
	"./message-square.svg": 9653,
	"./message.svg": 72008,
	"./messages-automated.svg": 52120,
	"./mic-off.svg": 24032,
	"./mic-on.svg": 65899,
	"./mic.svg": 30316,
	"./minimize-2.svg": 57950,
	"./minimize.svg": 6681,
	"./minus-circle.svg": 53465,
	"./minus-fill.svg": 53099,
	"./minus-square.svg": 49553,
	"./minus.svg": 85322,
	"./moon-fill.svg": 57791,
	"./moon-stars-fill.svg": 98904,
	"./moon-stars.svg": 92546,
	"./moon.svg": 82974,
	"./more-fill.svg": 90421,
	"./more-horizontal-fill.svg": 74578,
	"./more-horizontal.svg": 73827,
	"./more-vertical.svg": 2668,
	"./more.svg": 14341,
	"./move.svg": 42558,
	"./music.svg": 37987,
	"./navigation-2-fill.svg": 18842,
	"./navigation-2.svg": 16879,
	"./navigation-fill.svg": 81984,
	"./navigation.svg": 85785,
	"./note-fill.svg": 26447,
	"./note.svg": 48062,
	"./notes-fill.svg": 80362,
	"./notes.svg": 77344,
	"./notification-fill.svg": 96558,
	"./notification-off-fill.svg": 10315,
	"./notification-off.svg": 72623,
	"./notification-zz.svg": 12758,
	"./notification.svg": 50194,
	"./octagon-fill.svg": 8766,
	"./octagon.svg": 12587,
	"./package.svg": 79368,
	"./pause-circle-fill.svg": 3462,
	"./pause-circle.svg": 75876,
	"./pause-fill.svg": 213,
	"./pause.svg": 25950,
	"./pencil-edit-fill.svg": 40718,
	"./pencil-edit.svg": 42215,
	"./pencil.svg": 47663,
	"./percent-fill.svg": 67073,
	"./percent.svg": 34672,
	"./phone-call-fill.svg": 92800,
	"./phone-call.svg": 76309,
	"./phone-dialpad.svg": 36420,
	"./phone-fill.svg": 80542,
	"./phone-forwarded-fill.svg": 43604,
	"./phone-forwarded.svg": 47744,
	"./phone-incoming-fill.svg": 24455,
	"./phone-incoming.svg": 46408,
	"./phone-missed-fill.svg": 71283,
	"./phone-missed.svg": 53390,
	"./phone-off-fill.svg": 90464,
	"./phone-off.svg": 79281,
	"./phone-outgoing-fill.svg": 33381,
	"./phone-outgoing.svg": 85314,
	"./phone-rejected-fill.svg": 63184,
	"./phone-rejected.svg": 98341,
	"./phone.svg": 24386,
	"./pie-chart-fill.svg": 76659,
	"./pie-chart.svg": 55945,
	"./pin-fill.svg": 60071,
	"./pin.svg": 64241,
	"./pipeline-fill.svg": 11027,
	"./pipeline.svg": 85753,
	"./play-circle-fill.svg": 27175,
	"./play-circle.svg": 57525,
	"./play-fill.svg": 81905,
	"./play.svg": 78670,
	"./playbook.svg": 86393,
	"./plus-square.svg": 97535,
	"./pocket.svg": 81622,
	"./pound.svg": 56378,
	"./power.svg": 62142,
	"./printer.svg": 96451,
	"./profile-fill.svg": 19034,
	"./profile.svg": 90501,
	"./qr-code.svg": 5162,
	"./quote-euro.svg": 76949,
	"./quote-pound.svg": 56301,
	"./quote.svg": 65425,
	"./radio.svg": 80446,
	"./receipt-euro-filled.svg": 69289,
	"./receipt-euro.svg": 58280,
	"./receipt-filled.svg": 14104,
	"./receipt-pound-filled.svg": 98659,
	"./receipt-pound.svg": 60062,
	"./receipt.svg": 49910,
	"./recurring-euro.svg": 64174,
	"./recurring-pound.svg": 61061,
	"./recurring.svg": 70891,
	"./redo.svg": 88709,
	"./refresh-ccw.svg": 91790,
	"./refresh-cw-sync.svg": 35767,
	"./refresh-cw.svg": 72836,
	"./rename.svg": 14970,
	"./replace.svg": 14679,
	"./resize.svg": 65914,
	"./rewind.svg": 66286,
	"./rotate-ccw.svg": 35967,
	"./rotate-cw-redo.svg": 61980,
	"./rotate-cw.svg": 92977,
	"./rss.svg": 37247,
	"./sales money-fill.svg": 18870,
	"./sales-euro-fill.svg": 11553,
	"./sales-euro.svg": 30160,
	"./sales-fill.svg": 88656,
	"./sales-pound-fill.svg": 56906,
	"./sales-pound.svg": 46427,
	"./sales.svg": 94626,
	"./save.svg": 88725,
	"./scissors.svg": 8297,
	"./search-fill.svg": 64663,
	"./search.svg": 87999,
	"./send.svg": 74489,
	"./server.svg": 7651,
	"./settings-fill.svg": 41704,
	"./settings.svg": 9843,
	"./share-2.svg": 2497,
	"./share-content-filled.svg": 94244,
	"./share-content.svg": 74221,
	"./share.svg": 34560,
	"./shield-fill.svg": 76175,
	"./shield-off.svg": 46933,
	"./shield.svg": 58565,
	"./shopping-bag.svg": 83768,
	"./shopping-cart.svg": 13486,
	"./shuffle.svg": 83656,
	"./sidebar-collapse.svg": 67881,
	"./sidebar-expand.svg": 37482,
	"./sidebar.svg": 31600,
	"./sign-in-log-in.svg": 16747,
	"./skip-back.svg": 3989,
	"./skip-forward.svg": 91629,
	"./slack.svg": 59210,
	"./slash.svg": 17936,
	"./sliders.svg": 83387,
	"./sort.svg": 13253,
	"./speaker.svg": 61074,
	"./square-fill.svg": 85153,
	"./square.svg": 42775,
	"./star-fill.svg": 19682,
	"./star.svg": 98175,
	"./stop-circle.svg": 59301,
	"./strategy.svg": 76932,
	"./strikethrough.svg": 80790,
	"./sun-fill.svg": 33560,
	"./sun.svg": 39977,
	"./sunrise.svg": 20436,
	"./sunset.svg": 7132,
	"./switch-left-fill.svg": 59859,
	"./switch-left.svg": 9749,
	"./switch-right-fill.svg": 87591,
	"./switch-right.svg": 88695,
	"./tag-fill.svg": 3488,
	"./tag.svg": 82289,
	"./target.svg": 30728,
	"./tasks-fill.svg": 88494,
	"./tasks.svg": 43889,
	"./templates-fill.svg": 55952,
	"./templates.svg": 80123,
	"./terminal.svg": 22515,
	"./thermometer-fill.svg": 19873,
	"./thermometer.svg": 56743,
	"./thumbs-down.svg": 50968,
	"./thumbs-up.svg": 23535,
	"./toggle-left.svg": 80570,
	"./toggle-right.svg": 26248,
	"./trash-2-fill.svg": 83739,
	"./trash-2.svg": 79473,
	"./trash-fill.svg": 64952,
	"./trash.svg": 85052,
	"./trending-down.svg": 75225,
	"./trending-up.svg": 84934,
	"./triangle-fill.svg": 88263,
	"./triangle.svg": 86475,
	"./truck.svg": 11318,
	"./tv.svg": 60823,
	"./twitter-fill.svg": 16298,
	"./twitter.svg": 35455,
	"./type-off.svg": 82167,
	"./type-size.svg": 24691,
	"./type.svg": 45768,
	"./umbrella-fill.svg": 61822,
	"./umbrella.svg": 30881,
	"./underline.svg": 46671,
	"./undo.svg": 19898,
	"./union.svg": 58062,
	"./unlock.svg": 68602,
	"./upload-cloud.svg": 92589,
	"./upload.svg": 87975,
	"./user-check.svg": 89005,
	"./user-fill.svg": 72465,
	"./user-minus.svg": 76768,
	"./user-plus.svg": 44395,
	"./user-x.svg": 22837,
	"./user.svg": 63948,
	"./users-fill.svg": 51877,
	"./users.svg": 98291,
	"./video-fill.svg": 11121,
	"./video-off-fill.svg": 34345,
	"./video-off.svg": 14685,
	"./video.svg": 61926,
	"./view-desktop-fill.svg": 8551,
	"./view-desktop.svg": 34078,
	"./view-mobile.svg": 80358,
	"./view-tablet.svg": 48183,
	"./voicemail-fill.svg": 46066,
	"./voicemail.svg": 46686,
	"./volume-1.svg": 26931,
	"./volume-2.svg": 10960,
	"./volume-x.svg": 83757,
	"./volume.svg": 77163,
	"./watch-fill.svg": 8235,
	"./watch.svg": 84471,
	"./wifi-off.svg": 24217,
	"./wifi.svg": 7302,
	"./wind.svg": 2705,
	"./wordpress.svg": 83370,
	"./x-circle-fill.svg": 64200,
	"./x-circle.svg": 50973,
	"./x-square-fill.svg": 86461,
	"./x-square.svg": 59058,
	"./x.svg": 63217,
	"./youtube-fill.svg": 79195,
	"./youtube.svg": 56830,
	"./zap-fill.svg": 49198,
	"./zap-off-fill.svg": 37014,
	"./zap-off.svg": 55544,
	"./zap.svg": 69525,
	"./zoom-in.svg": 95130,
	"./zoom-out.svg": 89049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2764;